import React, { useEffect } from 'react';

export default function CalendlyEmbed({ isOpen, onClose }) {
  useEffect(() => {
    if (isOpen) {
      // Open Calendly in a new window
      window.open(
        'https://calendly.com/primeslink',
        'Calendly',
        'width=900,height=800,left=200,top=100'
      );

      // Close the modal state
      onClose();
    }
  }, [isOpen, onClose]);

  return null;
}
